import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** パスワード要件 */
enum PasswordRequirement {
  lowercase = '1',
  uppercase = '2',
  numbers = '3',
  symbols = '4',
}

const nameConfig = {
  lowercase: new Map([
    [Locale.ja, 'アルファベット小文字を含む'],
    [Locale.en, 'contains lowercase letter'],
  ]),
  uppercase: new Map([
    [Locale.ja, 'アルファベット大文字を含む'],
    [Locale.en, 'contains uppercase letter'],
  ]),
  numbers: new Map([
    [Locale.ja, '数字を含む'],
    [Locale.en, 'contains number'],
  ]),
  symbols: new Map([
    [Locale.ja, '特殊文字を含む'],
    [Locale.en, 'contains special character'],
  ]),
};

const toEnum = rawValueToEnum(PasswordRequirement, PasswordRequirement.lowercase);
const toDisplay = enumToName(PasswordRequirement, nameConfig);
const toDisplayWithPrefix = enumToName(PasswordRequirement, nameConfig, { prefix: true });

export const passwordRequirement = {
  enum: PasswordRequirement,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { PasswordRequirement };
